import React from "react";
import { usePublicEvents } from "@seabrookstudios/pitch2table";
import { useMakeListAndDetail, useMakeListBuilder } from "../core/useMakeLayout";
import { PublicEventListEntry } from "./PublicEventListEntry";
import { PublicEventDetailFromRoute } from "./PublicEventDetailFromRoute";
import Event from "@mui/icons-material/Event";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { NoItemsFound } from "../publisher/NoItemsFound";
import { SupportEmail } from "../core/CommonLinks";

const NoEvents = () => (
  <NoItemsFound>
    <Event />
    <p>No upcoming public events found.</p>
  </NoItemsFound>
);

const EventsListHeader = () => (
  <Box paddingBottom={1} paddingLeft={1} paddingRight={1}>
    <Alert severity="info">
      <Typography variant="body2">
        Pitch2Table maintains a catalogue of events that provide official play testing or pitching opportunities. Have
        an event to suggest? Email us at <SupportEmail subject="Event Suggestion" />.
      </Typography>
    </Alert>
  </Box>
);

/**
 * Extracts a unique identifier from a public event
 * @param {import("@seabrookstudios/pitch2table-core").CalendarEvent} item
 * @returns {string}
 */
const publicEventIdExtractor = (item) => {
  return item.slug || item.id?.toString() || "";
};

export const PublicEventListAndDetail = () => {
  const title = "Upcoming Events (Next 6 Months)";

  const useMakeList = useMakeListBuilder(
    PublicEventListEntry,
    publicEventIdExtractor,
    title,
    NoEvents,
    undefined,
    EventsListHeader
  );

  const ListAndDetail = useMakeListAndDetail(
    usePublicEvents,
    [],
    "public-events",
    useMakeList,
    PublicEventDetailFromRoute
  );

  return <ListAndDetail />;
};
